// @flow
import { shallowEqual, useSelector } from 'react-redux';


/**
 * Возвращает временной пояс текущего пользователя
 * В процессе loading, возвращает 'Europe/Moscow'
 */

export const useUserTimeZone = () => {
  const timezone = useSelector(state => state.user.timezone, shallowEqual);
  const loadingTimezone = useSelector(state => state.user.loading, shallowEqual);

  return [timezone, loadingTimezone];
};

export default useUserTimeZone;
